












import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import type { ProductForProductPageType } from '~/utils/types/solepro/Product';
import ProductIncipitInfo from './ProductIncipitInfo.vue';
import ProductGalleryIncipit from './ProductGalleryIncipit.vue';
import ProductIncipitInfoBook from './ProductIncipitInfoBook.vue';

export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        },
        isBook: {
            type: Boolean
        }
    },
    components: {
        ProductGalleryIncipit,
        ProductIncipitInfo,
        ProductIncipitInfoBook
    },
})
